import { Menu } from './Menu';
export class SeleccionAliadoCanalMenu {
    menu: Menu;
    confirmoUsuario: boolean;
}